import { getDialNumberFromOpenWidgetEvent } from 'calling-integration-sdk-support/utils/getDialNumberFromOpenWidgetEvent';
import { getValidatedNumberFromCalleeClient } from 'calling-integration-sdk-support/http/getValidatedNumberFromCalleeClient';
import { getIn } from 'calling-integration-sdk-support/utils/getIn';
import { logError } from 'calling-integration-sdk-support/utils/logError';
export const handleDialThirdParty = ({
  openWidgetEvent,
  ownerId,
  dialNumberProcessors = []
}) => {
  if (!openWidgetEvent || !openWidgetEvent.toSubject) {
    return;
  }
  const dialNumberDetails = openWidgetEvent && getDialNumberFromOpenWidgetEvent(openWidgetEvent);
  if (dialNumberDetails) {
    dialNumberProcessors.forEach(processor => processor(Object.assign({}, dialNumberDetails, {
      ownerId
    })));
  } else {
    const objectId = openWidgetEvent.toSubject.objectId || 0;
    const objectTypeId = openWidgetEvent.toSubject.objectTypeId || '';
    getValidatedNumberFromCalleeClient({
      objectId,
      objectTypeId
    }).then(phoneNumberProperty => {
      const numberPropertyName = getIn(['propertyName'], phoneNumberProperty);
      const updatedOpenWidgetEvent = {
        toSubject: Object.assign({}, openWidgetEvent.toSubject, {
          objectId,
          objectTypeId,
          phoneNumberProperties: [phoneNumberProperty],
          numberPropertyName
        })
      };
      const dialPayload = getDialNumberFromOpenWidgetEvent(updatedOpenWidgetEvent);
      dialNumberProcessors.forEach(processor => processor(Object.assign({}, dialPayload, {
        ownerId
      })));
    }).catch(e => {
      logError('Unable to send third party dial number payload', {
        error: e,
        level: 'info'
      });
    });
  }
};